/**
 * Gerador de arquivo PROCEDA - Padrão OCORREN (versão 5.0 / modelo 50)
 *
 * Registros de 250 posições cada, formato texto com tamanho fixo.
 * Tipos de registro: 000, 540, 541, 542, 543, 549
 */

const RECORD_SIZE = 250

function padRight(str, size) {
  const s = String(str || '')
  return s.length >= size ? s.substring(0, size) : s + ' '.repeat(size - s.length)
}

function padLeft(str, size, char = '0') {
  const s = String(str || '')
  return s.length >= size ? s.substring(0, size) : char.repeat(size - s.length) + s
}

function formatDateDDMMAA(date) {
  const d = new Date(date)
  const dd = padLeft(d.getDate(), 2)
  const mm = padLeft(d.getMonth() + 1, 2)
  const aa = padLeft(d.getFullYear() % 100, 2)
  return dd + mm + aa
}

function formatDateDDMMAAAA(date) {
  const d = new Date(date)
  const dd = padLeft(d.getDate(), 2)
  const mm = padLeft(d.getMonth() + 1, 2)
  const aaaa = padLeft(d.getFullYear(), 4)
  return dd + mm + aaaa
}

function formatDateDDMM(date) {
  const d = new Date(date)
  const dd = padLeft(d.getDate(), 2)
  const mm = padLeft(d.getMonth() + 1, 2)
  return dd + mm
}

function horaToHHMM(hora) {
  if (!hora) return '0000'
  // Accepts both "HH:MM" and "HHMM"
  const cleaned = hora.replace(':', '')
  return padLeft(cleaned.replace(/[^0-9]/g, ''), 4)
}

/**
 * Registro 000 - Cabeçalho de Intercâmbio (250 posições)
 *
 * Pos 001-003 (N3) : Identificador "000"
 * Pos 004-038 (A35): Remetente (nome da empresa/embarcadora)
 * Pos 039-073 (A35): Destinatário
 * Pos 074-079 (N6) : Data DDMMAA
 * Pos 080-083 (N4) : Hora HHMM
 * Pos 084-097 (A14): Identificação do intercâmbio – OCO50{DDMM}{id5}
 * Pos 098-250 (A153): Filler
 */
function buildRecord000({ remetente, destinatario, data, hora, identificadorIntercambio }) {
  let record = ''
  record += '000'                                           // 001-003
  record += padRight(remetente, 35)                         // 004-038
  record += padRight(destinatario, 35)                      // 039-073
  record += formatDateDDMMAA(data)                          // 074-079
  record += horaToHHMM(hora)                                // 080-083
  record += padRight(identificadorIntercambio, 14)          // 084-097
  record += padRight('', 153)                               // 098-250
  return record.substring(0, RECORD_SIZE)
}

/**
 * Registro 540 - Cabeçalho do Documento OCOREN (250 posições)
 *
 * Pos 001-003 (N3) : Identificador "540"
 * Pos 004-019 (A16): Identificação do documento – OCORR50{DDMM}{id5}
 * Pos 020-250 (A231): Filler
 */
function buildRecord540({ identificacaoDocumento }) {
  let record = ''
  record += '540'                                           // 001-003
  record += padRight(identificacaoDocumento, 16)            // 004-019
  record += padRight('', 231)                               // 020-250
  return record.substring(0, RECORD_SIZE)
}

/**
 * Registro 541 - Dados da Transportadora (250 posições)
 *
 * Pos 001-003 (N3): Identificador "541"
 * Pos 004-017 (N14): CNPJ da transportadora
 * Pos 018-067 (A50): Razão social
 * Pos 068-250 (A183): Filler
 */
function buildRecord541({ cnpj, razaoSocial }) {
  let record = ''
  record += '541'                                           // 001-003
  record += padLeft((cnpj || '').replace(/\D/g, ''), 14)                  // 004-017
  record += padRight(razaoSocial, 50)                       // 018-067
  record += padRight('', 183)                               // 068-250
  return record.substring(0, RECORD_SIZE)
}

/**
 * Registro 542 - Ocorrência na Entrega (250 posições)
 *
 * Pos 001-003 (N3) : Identificador "542"
 * Pos 004-017 (N14): CNPJ do emissor da NF (empresa/embarcadora)
 * Pos 018-020 (A3) : Série da NF  (“1  ” se nula)
 * Pos 021-029 (N9) : Identifier da delivery (9 dígitos, zero-padded)
 * Pos 030-032 (N3) : Código de ocorrência na entrega
 * Pos 033-040 (N8) : Data da ocorrência DDMMAAAA
 * Pos 041-044 (N4) : Hora da ocorrência HHMM
 * Pos 045-046 (N2) : Código de observação de ocorrência
 * Pos 047-250 (A204): Info adicional / campos complementares
 */
function buildRecord542({ cnpjEmissor, serieNf, identifier, codigoOcorrencia, dataOcorrencia, horaOcorrencia, codigoObservacao, infoAdicional }) {
  let record = ''
  record += '542'                                                            // 001-003
  record += padLeft((cnpjEmissor || '').replace(/[^\d]/g, ''), 14)          // 004-017
  record += padRight(serieNf || '1', 3)                                     // 018-020
  record += padLeft(String(identifier || ''), 9)                            // 021-029
  record += padLeft(String(codigoOcorrencia || ''), 3)                      // 030-032
  record += formatDateDDMMAAAA(dataOcorrencia)                               // 033-040
  record += horaToHHMM(horaOcorrencia)                                       // 041-044
  record += padLeft(String(codigoObservacao || ''), 2)                      // 045-046
  record += padRight(infoAdicional || '', 204)                               // 047-250
  return record.substring(0, RECORD_SIZE)
}

/**
 * Registro 543 - Texto Complementar (250 posições)
 *
 * Pos 001-003 (N3): Identificador "543"
 * Pos 004-073 (A70): Texto livre 1
 * Pos 074-143 (A70): Texto livre 2
 * Pos 144-213 (A70): Texto livre 3
 * Pos 214-250 (A37): Filler
 */
function buildRecord543({ textoLivre1, textoLivre2, textoLivre3 }) {
  let record = ''
  record += '543'                                           // 001-003
  record += padRight(textoLivre1, 70)                       // 004-073
  record += padRight(textoLivre2, 70)                       // 074-143
  record += padRight(textoLivre3, 70)                       // 144-213
  record += padRight('', 37)                                // 214-250
  return record.substring(0, RECORD_SIZE)
}

/**
 * Registro 549 - Finalizador de Ocorrência (250 posições)
 *
 * Pos 001-003 (N3): Identificador "549"
 * Pos 004-007 (N4): Número de registros de ocorrência (542)
 * Pos 008-250 (A243): Filler
 */
function buildRecord549({ totalOcorrencias }) {
  let record = ''
  record += '549'                                           // 001-003
  record += padLeft(totalOcorrencias, 4)                    // 004-007
  record += padRight('', 243)                               // 008-250
  return record.substring(0, RECORD_SIZE)
}

/**
 * Gera e faz download do arquivo OCORREN.
 */
export function gerarArquivoOcorren({ empresaNome, destinatario, dataCabecalho, horaCabecalho, identificadorDocumento, transportadora, entregas }) {
  const lines = []
  const transp = transportadora.value || transportadora

  const cnpjTransp = (transp.cnpj || '').replace(/\D/g, '')
  const razaoSocial = transp.nome || transp.razao_social || transp.nome_fantasia || transp.name || ''

  // Empresa remetente = nome da company selecionada na tela 3.9
  const remetente = empresaNome || ''

  // Identificador com 5 dígitos
  const seqIntercambio = padLeft(String(identificadorDocumento || ''), 5)

  // Montar identificação do intercâmbio: OCO50{DDMM}{id5} = 14 chars
  const ddmm = formatDateDDMM(dataCabecalho)
  const identificadorIntercambio = 'OCO50' + ddmm + seqIntercambio

  // Montar identificação do documento: OCORR50{DDMM}{id5} = 16 chars
  const identificacaoDocumento = 'OCORR50' + ddmm + seqIntercambio

  // 000 - Cabeçalho de intercâmbio
  lines.push(
    buildRecord000({
      remetente,
      destinatario,
      data: dataCabecalho,
      hora: horaCabecalho,
      identificadorIntercambio,
    }),
  )

  // 540 - Cabeçalho do documento
  lines.push(
    buildRecord540({
      identificacaoDocumento,
    }),
  )

  // 541 - Dados da transportadora
  lines.push(
    buildRecord541({
      cnpj: cnpjTransp,
      razaoSocial,
    }),
  )

  // 542 + 543 para cada entrega
  let totalOcorrencias = 0
  entregas.forEach(entrega => {
    totalOcorrencias++

    lines.push(
      buildRecord542({
        cnpjEmissor: entrega.company_cnpj || '',
        serieNf: entrega.invoice_serie || entrega.serie_nf || '1',
        identifier: entrega.identifier || '',
        codigoOcorrencia: entrega._codigo_ocorrencia,
        dataOcorrencia: entrega._data_ocorrencia,
        horaOcorrencia: entrega._hora_ocorrencia,
        codigoObservacao: entrega._codigo_observacao,
        infoAdicional: entrega._info_adicional || '',
      }),
    )

    // Se tiver texto complementar, gerar registro 543
    if (entrega._texto_livre_1 || entrega._texto_livre_2 || entrega._texto_livre_3) {
      lines.push(
        buildRecord543({
          textoLivre1: entrega._texto_livre_1 || '',
          textoLivre2: entrega._texto_livre_2 || '',
          textoLivre3: entrega._texto_livre_3 || '',
        }),
      )
    }
  })

  // 549 - Finalizador
  lines.push(
    buildRecord549({
      totalOcorrencias,
    }),
  )

  // Gerar conteúdo do arquivo
  const content = lines.join('\n')

  // Download
  const blob = new Blob([content], { type: 'text/plain;charset=utf-8' })
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  const now = new Date()
  const fileName = `OCOREN_${destinatario.replace(/\s+/g, '_').substring(0, 20)}_${padLeft(now.getDate(), 2)}${padLeft(now.getMonth() + 1, 2)}${now.getFullYear()}${padLeft(now.getHours(), 2)}${padLeft(now.getMinutes(), 2)}${padLeft(now.getSeconds(), 2)}.TXT`
  a.href = url
  a.download = fileName
  a.click()
  window.URL.revokeObjectURL(url)
}
